import React from 'react';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import Sidebar from '../components/sidebar/Sidebar';

interface DashboardLayoutProps {
  children: React.ReactNode; // dynamic content
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <div className='flex h-screen'>

      <Sidebar/>

      <div className="ml-64 flex flex-col flex-1 min-h-screen">
        {/* Common Header */}
        <Header loggedIn={true}/>

        {/* Dynamic Content */}
          <main className="flex-grow flex">
            <div className="w-full">{children}</div>
        </main>

        {/* Common Footer */}
        <Footer />
      </div>
    </div>
  );
};

export default DashboardLayout;









